import {useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import type {NavTab} from 'UI/components/layout/NavigationBar/NavigationBar';

import {AUTH_TABS, GUEST_TABS} from 'Shared/navigation';
import {useAuth} from 'UI/hooks/useAuth';

/**
 * Hook für das AppLayout. Bestimmt anhand des Auth-Status die Navigation-Tabs
 * und übersetzt die Labels via i18n.
 *
 * @returns Übersetzte Navigation-Tabs passend zum Auth-Status.
 */
export const useAppLayout = (): NavTab[] => {
    const {isAuthenticated} = useAuth();
    const {t} = useTranslation();

    return useMemo(
        () => (isAuthenticated ? AUTH_TABS : GUEST_TABS).map(tab => ({
            ...tab,
            label: t(tab.label)
        })),
        [isAuthenticated, t]
    );
};